export default "__VITE_ASSET__B73WUu5g__"